
import { Injectable } from '@angular/core';
import { BackendService } from '../backend.service';
import { SessionStorageService } from 'ngx-webstorage';
import { TokenService } from '../token/token.service';
import { ApplicationService } from '../application/application.service';

@Injectable()
export class AadhaarService {

  private aadhaarCheckUrl = '/aadhaar/api/v1/{customerId}/kyc';
  private storeAadhaarDataInPersonalDetailsUrl = '/PersonalDetails/Customers/{customerId}/AadhaarVerifications';
  private getAadhaarFormParameterUrl = '/aadhaar/api/v1/{customerId}/initKyc/{aadhaarNumber}?merchantIdSource={merchantId}';
  private verifyAadhaarUrl = '/aadhaar/api/v1/{requestId}/aadhaarResponse?{data}';
  private checkAadhaarUniqueUrl = '/PersonalDetails/SocialDetails/Customers/{customerId}/Aadhaar/{aadhaarNumber}/status';
  private storeTemporaryAadhaar = '/PersonalDetails/Aadhaar';
  private AadhaarServerUpUrl = '/ekyc.json';

  constructor(private backendService: BackendService, private sessionStorage: SessionStorageService, private tokenService: TokenService, private applicationService: ApplicationService) { }

  checkAadhaar(): any {
    return this.backendService.getData(this.aadhaarCheckUrl);
  }
  storeAadhaar(): any {
    return this.backendService.setData(this.storeAadhaarDataInPersonalDetailsUrl);
  }
  getFromParameters(aadhaarNumber): any {
    let url = this.getAadhaarFormParameterUrl;
    if (this.applicationService.getMerchantId()) {
      url = this.getAadhaarFormParameterUrl.replace('{merchantId}', this.applicationService.getMerchantId());
    } else {
      url = this.getAadhaarFormParameterUrl.replace('?merchantIdSource={merchantId}', '');
    }
    return this.backendService.setData(url.replace(/{aadhaarNumber}/, aadhaarNumber));
  }
  verfiyResponse(requestId, data): any {
    return this.backendService.setData(this.verifyAadhaarUrl.replace('{requestId}', requestId).replace('{data}', data));
  }
  saveAadhaar(aadhaar: string): any {
    this.sessionStorage.store('zest-aadhaar', aadhaar);
    const aadhaarData = {
      Aadhaar: aadhaar,
      CustomerId: this.tokenService.getCustomerId()
    };
    return this.backendService.setData(this.storeTemporaryAadhaar, aadhaarData);
  }
  storeInSession(aadhaar: string) {
    this.sessionStorage.store('zest-aadhaar', aadhaar);
  }
  getAadhaar() {
    return this.sessionStorage.retrieve('zest-aadhaar');
  }
  checkAadhaarUnique(aadhaarNumber): any {
    return this.backendService.getData(this.checkAadhaarUniqueUrl.replace(/{aadhaarNumber}/, aadhaarNumber));
  }
  checkAadhaarServer(): any {
    return this.backendService.getData(this.AadhaarServerUpUrl, null, false, true, true);
  }

}
